(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Index-top-explore-slider-new"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init() {
    document.querySelectorAll('[data-home-explore]').forEach(slide => {
      if (slide.dataset.exploreReady) return;
      const video = slide.querySelector('.ga-home-explore-video');
      const button = slide.querySelector('.ga-home-explore-motion');
      if (!video || !button) return;
      slide.dataset.exploreReady = 'true';
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let visitorPaused = motion.matches;
      let visible = false;
      const label = () => { button.textContent = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel; };
      const sync = () => {
        if (visible && slide.classList.contains('swiper-slide-active') && !document.hidden && !visitorPaused) video.play().catch(label);
        else video.pause();
        label();
      };
      button.addEventListener('click', () => { visitorPaused = !video.paused; sync(); });
      video.addEventListener('play', label);
      video.addEventListener('pause', label);
      document.addEventListener('visibilitychange', sync);
      new MutationObserver(sync).observe(slide, {attributes:true, attributeFilter:['class']});
      motion.addEventListener('change', () => { visitorPaused = motion.matches; sync(); });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.35);
          sync();
        }, {threshold:[0,0.35]});
        observer.observe(video);
      } else {
        visible = true;
        visitorPaused = true;
      }
      label();
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-gerry-hub"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-play-gerry]');if(!button)return;const root=button.closest('[data-gerry-video]');if(!root||root.querySelector('iframe'))return;const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/E4vvYSeHSE8?autoplay=1&rel=0';frame.title=button.getAttribute('aria-label');frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;root.replaceChildren(frame);frame.focus();});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-gift-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ga-gift-finder')) {
  customElements.define('ga-gift-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.results = this.querySelector('.ga-gifts__results');
      this.cards = [...this.querySelectorAll('[data-gift-card]')];
      this.status = this.querySelector('[role="status"]');
      this.more = this.querySelector('.ga-gifts__more');
      this.share = this.querySelector('.ga-gifts__share');
      this.form.hidden = false;
      this.results.hidden = true;
      this.form.addEventListener('submit', event => { event.preventDefault(); this.apply(true); });
      this.form.addEventListener('change', () => { if (!this.results.hidden) this.apply(false); });
      this.more.addEventListener('click', () => { this.matches.forEach(card => { card.hidden = false; }); this.more.hidden = true; });
      this.querySelector('.ga-gifts__broaden').addEventListener('click', () => { this.form.elements.budget.value = 'any'; this.form.elements.interest.value = 'any'; this.apply(true); });
      this.share.addEventListener('click', () => this.copy());
      this.addEventListener('click', event => {
        const link = event.target.closest('a');
        const card = link && link.closest('[data-gift-card]');
        if (card) this.track('gift_finder_product_click', { item_id: card.dataset.product, gift_show: card.dataset.show, gift_interest: card.dataset.interest });
      });
      const restore = () => {
        const params = new URLSearchParams(location.hash.slice(1));
        if (!params.has('gift_show')) return;
        for (const key of ['show', 'budget', 'interest']) {
          const value = params.get('gift_' + key);
          const select = this.form.elements[key];
          if ([...select.options].some(option => option.value === value)) select.value = value;
        }
        this.apply(false, false);
      };
      restore();
      window.addEventListener('hashchange', restore);
    }
    apply(focus, measure = true) {
      const show = this.form.elements.show.value;
      const budget = this.form.elements.budget.value;
      const interest = this.form.elements.interest.value;
      this.matches = this.cards.filter(card => (show === 'any' || card.dataset.show === show) && (interest === 'any' || card.dataset.interest === interest) && (budget === 'any' || Number(card.dataset.price) <= Number(budget)));
      this.cards.forEach(card => { card.hidden = true; });
      this.matches.slice(0, 3).forEach(card => { card.hidden = false; });
      this.results.hidden = false;
      this.more.hidden = this.matches.length <= 3;
      this.share.hidden = this.matches.length === 0;
      this.querySelector('.ga-gifts__empty').hidden = this.matches.length !== 0;
      this.querySelector('.ga-gifts__copy-label').hidden = true;
      this.status.textContent = this.matches.length ? this.dataset.count.replace('[count]', String(this.matches.length)) : this.dataset.none;
      const hash = new URLSearchParams({ gift_show: show, gift_budget: budget, gift_interest: interest });
      history.replaceState(history.state, '', location.pathname + location.search + '#' + hash);
      if (focus) this.results.querySelector('h2').focus({ preventScroll: false });
      if (measure) this.track('gift_finder_results', { gift_show: show, gift_budget: budget, gift_interest: interest, result_count: this.matches.length });
    }
    async copy() {
      const url = new URL(location.href);
      for (const key of [...url.searchParams.keys()]) if (key !== 'view' && key !== 'preview_theme_id') url.searchParams.delete(key);
      if (this.dataset.themeRole !== 'main') url.searchParams.set('preview_theme_id', this.dataset.themeId);
      try {
        await navigator.clipboard.writeText(url.toString());
        this.status.textContent = this.dataset.copySuccess;
        this.track('gift_finder_share', { gift_show: this.form.elements.show.value });
      } catch (_) {
        const label = this.querySelector('.ga-gifts__copy-label');
        const input = label.querySelector('input');
        label.hidden = false;
        input.value = url.toString();
        input.focus();
        input.select();
        this.status.textContent = this.dataset.copyFallback;
      }
    }
    track(name, parameters) {
      try {
        if (window.top !== window || document.hidden) return;
        const privacy = window.Shopify && window.Shopify.customerPrivacy;
        if (!privacy || !privacy.analyticsProcessingAllowed || !privacy.analyticsProcessingAllowed()) return;
        const preview = this.dataset.themeRole !== 'main';
        const data = { ...parameters, send_to: 'G-GTDP3JFKMX', content_group: 'gift_finder', currency: this.dataset.currency, universe_environment: preview ? 'preview' : 'live', page_location: location.origin + location.pathname };
        if (preview) data.debug_mode = true;
        window.dataLayer = window.dataLayer || [];
        function send() { window.dataLayer.push(arguments); }
        send('event', name, data);
      } catch (_) {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ga-world-index"]) return;
  try {
    
function startWorldSearch(){
  const fold=value=>String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().replace(/[^a-z0-9]+/g,' ').trim();
  document.querySelectorAll('[data-world-index]').forEach(root=>{
    const input=root.querySelector('[data-world-search]');if(!input||input.dataset.ready)return;input.dataset.ready='true';
    const result=root.querySelector('[data-world-result]'),clear=root.querySelector('[data-world-clear]');
    const cards=[...root.querySelectorAll('[data-world-card]')].map(card=>({card,search:fold(card.dataset.search),compact:fold(card.dataset.search).replace(/ /g,'')}));
    const apply=()=>{const query=fold(input.value),words=query.split(/\s+/).filter(Boolean);let count=0;
      cards.forEach(({card,search,compact})=>{const match=words.every(w=>search.includes(w)||compact.includes(w));card.hidden=!match;if(match)count++;});
      root.querySelectorAll('[data-world-group]').forEach(group=>{group.hidden=![...group.querySelectorAll('[data-world-card]')].some(c=>!c.hidden);const link=root.querySelector('a[href="#'+group.id+'"]');if(link)link.hidden=group.hidden;});
      result.hidden=!query;result.textContent=count+' '+(count===1?result.dataset.resultSingular:result.dataset.resultLabel);if(clear)clear.hidden=!input.value;
    };
    input.addEventListener('input',apply);if(clear)clear.addEventListener('click',()=>{input.value='';apply();input.focus();});
  });
}startWorldSearch();document.addEventListener('shopify:section:load',startWorldSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.querySelector('predictive-search[open]') || this.contains(document.activeElement)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"]) return;
  try {
    
(function(){
  function initialise(scope){
    scope.querySelectorAll('.ga404').forEach(function(root){
      if(root.dataset.ga404Ready)return;
      var source=root.querySelector('[data-ga404-missions]');
      var panel=root.querySelector('[data-ga404-computer]');
      var choose=root.querySelector('[data-ga404-choose]');
      var assignment=root.querySelector('[data-ga404-assignment]');
      var message=root.querySelector('[data-ga404-message]');
      var go=root.querySelector('[data-ga404-go]');
      if(!source||!panel||!choose||!assignment||!message||!go)return;
      var missions;
      try{missions=JSON.parse(source.textContent)}catch(error){return}
      if(!Array.isArray(missions)||!missions.length)return;
      root.dataset.ga404Ready='true';
      panel.hidden=false;
      var previous=-1;
      choose.addEventListener('click',function(){
        var next=Math.floor(Math.random()*missions.length);
        if(next===previous&&missions.length>1)next=(next+1)%missions.length;
        var mission=missions[next];
        if(!mission||typeof mission.url!=='string'||!mission.url.startsWith('/')||mission.url.startsWith('//'))return;
        previous=next;
        assignment.hidden=false;
        message.textContent=mission.message;
        go.setAttribute('href',mission.url);
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){initialise(document)})}else{initialise(document)}
  document.addEventListener('shopify:section:load',function(event){initialise(event.target)});
})();

  } catch(e) { console.error(e); }
})();
})();
